<template>
  <div id="slides">
    <div class="bd">
      <div class="tempWrap" style="overflow:hidden;position:relative;width:1200px">
        <ul style="width: 1200px; left: 0px; position: relative; overflow: hidden; padding: 0px; margin: 0px;">
          <li style="float: left; width: 1200px;">
            <a href=""><img src="../assets/css/images/201910181120101365.jpeg" alt="">
            </a>
          </li>
        </ul>
      </div>
    </div>
<!--    <div class="hd">-->
<!--      <ul>-->
<!--        <li class="on">1</li>-->
<!--      </ul>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Slider"
}
</script>

<style scoped>

</style>